import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';

@Component({
  selector: 'app-question-login',
  templateUrl: './question-login.component.html',
  styleUrls: ['./question-login.component.scss']
})
export class QuestionLoginComponent implements OnInit {

  constructor(
    public dialogRef: MatDialogRef<QuestionLoginComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any
  ) { }

  ngOnInit() {
  }

  onNoClick() {
    this.dialogRef.close();
  }

  onDoneClick() {
    this.dialogRef.close(true);
  }

}
